module.exports = __webpack_public_path__ + "concierge.49a0a844.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/concierge.png
// module id = 559
// module chunks = 0